import React from "react";

const VisitIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="url(#pattern0_2578_24)" />
      <defs>
        <pattern
          id="pattern0_2578_24"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="scale(0.00195312)" />
        </pattern>
      </defs>
    </svg>
  );
};

export default VisitIcon;
